import * as Yup from 'yup'

export const NewManualInfluencerSchema = Yup.object().shape({
  full_name: Yup.string().required('You must enter a name.'),
  provider: Yup.string().required('You must select a provider.'),
  username: Yup.string().required('You must enter a username.'),
});
